import React from 'react';
import Register from '../components/Register/Register';

function SignUpPage() {
  return <Register />;
}

export default SignUpPage;
